import { Action } from "..";
import { MaterialUpdate } from "../../types/materialUpdate";

export const LAST_MATERIAL_UPDATED_CHANGE = "LAST_MATERIAL_UPDATED_CHANGE";

export function setLastMaterialUpdated(material: MaterialUpdate): Action {
  return { type: LAST_MATERIAL_UPDATED_CHANGE, payload: material };
}
